<div class="order-history-container">
  <ng-container *ngIf="(ordersHistoryList$ | async)?.length;else emptyTable">
    <form class="table-controls-container" [formGroup]="orderHistoryControlsForm">
      <div class="header-container">
        <div class="text-title-2">Purchase Orders</div>
        <div class="sub-header">
          There are
          <div class="bold">{{(ordersHistoryList$ | async)?.length}}</div>
          purchase order{{(ordersHistoryList$ | async)?.length !== 1 ? 's' : ''}} on file.
        </div>
      </div>

      <div class="table-controls">
        <app-search-input formControlName="searchValue"
                          [color]="SearchInputColorEnum.Green"
                          [hideDropdown]="true"
                          [placeholder]="'Search by wholesaler, PO #, invoice # or CSOS #'"
                          [loading]="(loading$ | async) === true"
        ></app-search-input>
      </div>
    </form>

    <app-tabs (tabSelected)="tabChanged($event)" [tabsMarginLeft]="'32px'">
      <app-tab [tabValue]="OrderHistoryStatusesEnum.All"
              [count]="ordersHistoryAllFiltered?.length"
              [tabTitle]="'All'"
              [active]="currentTab === OrderHistoryStatusesEnum.All"
      >
        <app-inventory-empty-splash *ngIf="(loading$ | async) !== true && !ordersHistoryAll.length"
                                    [message]="'You don’t have any purchase orders yet.'"
                                    [header]="'Purchase Orders History'"
        ></app-inventory-empty-splash>
        <app-order-history-table *ngIf="ordersHistoryAll.length"
                                [ordersHistoryList]="ordersHistoryAllFiltered"
                                [loading]="loading$ | async"
        ></app-order-history-table>
        <app-search-empty-splash
          *ngIf="(loading$ | async) !== true && ordersHistoryAll.length && !ordersHistoryAllFiltered.length"
          [searchValue]="orderHistoryControlsForm.get('searchValue').value"
        ></app-search-empty-splash>
      </app-tab>

      <app-tab [tabValue]="OrderHistoryStatusesEnum.Received"
              [count]="ordersHistoryReceivedFiltered?.length"
              [tabTitle]="'Received'"
              [active]="currentTab === OrderHistoryStatusesEnum.Received"
      >
        <app-inventory-empty-splash *ngIf="(loading$ | async) !== true && !ordersHistoryReceived.length"
                                    [message]="'You don’t have received purchase orders history yet.'"
                                    [header]="'Purchase Orders History'"
        ></app-inventory-empty-splash>
        <app-order-history-table *ngIf="ordersHistoryReceived.length"
                                [ordersHistoryList]="ordersHistoryReceivedFiltered"
                                [loading]="loading$ | async"
        ></app-order-history-table>
        <app-search-empty-splash
          *ngIf="(loading$ | async) !== true && ordersHistoryReceived.length && !ordersHistoryReceivedFiltered.length"
          [searchValue]="orderHistoryControlsForm.get('searchValue').value"
        ></app-search-empty-splash>
      </app-tab>

      <app-tab [tabValue]="OrderHistoryStatusesEnum.NotReceived"
              [count]="ordersHistoryNotReceivedFiltered?.length"
              [tabTitle]="'Not Received'"
              [active]="currentTab === OrderHistoryStatusesEnum.NotReceived"
      >
        <app-inventory-empty-splash *ngIf="(loading$ | async) !== true && !ordersHistoryNotReceived.length"
                                    [message]="'You don’t have non-received purchase orders history yet.'"
                                    [header]="'Purchase Orders History'"
        ></app-inventory-empty-splash>
        <app-order-history-table *ngIf="ordersHistoryNotReceived.length"
                                [ordersHistoryList]="ordersHistoryNotReceivedFiltered"
                                [loading]="loading$ | async"
        ></app-order-history-table>
        <app-search-empty-splash
          *ngIf="(loading$ | async) !== true && ordersHistoryNotReceived.length && !ordersHistoryNotReceivedFiltered.length"
          [searchValue]="orderHistoryControlsForm.get('searchValue').value"
        ></app-search-empty-splash>
      </app-tab>
  </app-tabs>
 </ng-container>
    <ng-template #emptyTable>
      <div class="table-controls-container header-container">
        <div class="text-title-2">Orders</div>
      </div>
      <app-empty-table *ngIf="(loading$ | async) !== true && !ordersHistoryNotReceived.length"
                       [labelValue]="'You do not have any orders yet'"
      ></app-empty-table>
  </ng-template>
</div>
